module.exports = __webpack_public_path__ + "static/media/pinned-tag-red.9565bba2.svg";